// Native
import { Badge, Box, DataList, HStack, Progress, Stack, Text } from "@chakra-ui/react"

// Custom
import { UI } from "components"
import usePointsReport from "hooks/usePointsReport"
import useUser from "hooks/useUser"

export default function Points(){

    const user = useUser()
    const report = usePointsReport()
    const career = user.data?.consultant?.career?.current_career

    return(
    <UI.Box loading={user.isLoading || report.isLoading}>
        <Stack>
            
            <Box>
                <Text children="Pontos qualificáveis:" color="GrayText" />
                <HStack>
                    <Text children={<UI.Number.Number value={user.data?.consultant?.qualified_points_balance} />} fontSize="2xl" fontWeight="bold" />
                    <Text fontSize="sm">/ <UI.Number.Number value={report.data?.next_career?.points} /></Text>
                    <Badge colorPalette="orange" size="sm">Próximo pin</Badge>
                </HStack>
                
                <Progress.Root maxW="240px" striped animated mt={2} colorPalette="purple" value={report.data?.for_upgrade_percentage}>
                    <Progress.Track>
                        <Progress.Range />
                    </Progress.Track>
                </Progress.Root>
            </Box>

            <Text children="Relatório de pontos:" color="GrayText" />

            <DataList.Root orientation="horizontal">

                <DataList.Item>
                    <DataList.ItemLabel>Pontos totais:</DataList.ItemLabel>
                    <DataList.ItemValue><UI.Number.Number value={report.data?.total} /></DataList.ItemValue>
                </DataList.Item>

                <DataList.Item>
                    <DataList.ItemLabel>Pontos pessoais:</DataList.ItemLabel>
                    <DataList.ItemValue><UI.Number.Number value={report.data?.personal} /></DataList.ItemValue>
                </DataList.Item>

                <DataList.Item>
                    <DataList.ItemLabel>Acima da VME:</DataList.ItemLabel>
                    <DataList.ItemValue><UI.Number.Number value={report.data?.overflow} /></DataList.ItemValue>
                </DataList.Item>

                <DataList.Item>
                    <DataList.ItemLabel>Antecipados:</DataList.ItemLabel>
                    <DataList.ItemValue><UI.Number.Number value={report.data?.anticipated} /></DataList.ItemValue>
                </DataList.Item>
                
            </DataList.Root>

        </Stack>

    </UI.Box>
    )
}